import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const BannerWidgetGridLayoutStyle = styled.div`
  padding: 0 15px;
  img {
    width: 100%;
    border-radius: 2px;
  }
`;
